import { PortraitState, updatePlayerState } from 'core/slices/player';
import { eventChannel } from 'redux-saga';
import { fork, all, call, take, select, put } from 'redux-saga/effects';
import { RootState } from 'types';

export function windowEvents() {
  return eventChannel(emitter => {
    window.addEventListener('resize', emitter);
    window.addEventListener('orientationchange', emitter);

    document.body.addEventListener('wheel', e => {
      if (e.ctrlKey) e.preventDefault(); //prevent zoom
    });

    return () => {
      window.removeEventListener('resize', emitter);
      window.removeEventListener('orientationchange', emitter);
    };
  });
}

function* updatePortrait() {
  const { portrait } = yield select((state: RootState) => state.core.player.state);
  if (!portrait && window.matchMedia('(orientation: portrait)').matches)
    yield put(yield call(updatePlayerState, { portrait: PortraitState.TRUE_PORTRAIT }));
  else if (portrait && !window.matchMedia('(orientation: portrait)').matches)
    yield put(yield call(updatePlayerState, { portrait: PortraitState.NOT_PORTRAIT }));
}

function* watchResize() {
  const events = yield call(windowEvents);
  while (true) {
    yield take(events);
    yield updatePortrait();
  }
}

export function* windowSaga() {
  yield all([fork(watchResize), fork(updatePortrait)]);
}
